export class TrainPassData{
    public workingStatus: string
    public ym: string
    public empCd: string
    public empNm: string
    public divisionNm: string
    public divisionSnm: string
    public startYmd: Date
    public endYmd: Date
    public requestStatus: string
    public trainPassPurchaseFlg: boolean
    public sameLastRouteFlg: boolean
    public sameLastMonthFlg: boolean
    public passKey1: string               
    public passPrice1: string             
    public startStation1: string          
    public endStation1: string            
    public transitStation1: string        
    public startStation1Cd: string        
    public endStation1Cd: string          
    public transitStation1Cd: string      
    public trainPassInfo1: string         
    public passKey2: string                    
    public passPrice2: string                  
    public startStation2: string               
    public endStation2: string                 
    public transitStation2: string             
    public startStation2Cd: string             
    public endStation2Cd: string               
    public transitStation2Cd: string           
    public trainPassInfo2: string              
    public passKey3: string                    
    public passPrice3: string                  
    public startStation3: string               
    public endStation3: string                 
    public transitStation3: string             
    public startStation3Cd: string             
    public endStation3Cd: string               
    public transitStation3Cd: string           
    public trainPassInfo3: string              
    public passPriceMostLow: number       
    public trainPassMostLowInfo: string   
    public passRemarks: string
    public decisionRemarks: string
    public decisionDate: string
    public decisionEmpCd: string
    public approvalDate1st: string
    public approvalEmpCd1st: string
    public approvalEmpNm1st: string
    public approvalDate2nd: string
    public approvalEmpCd2nd: string
    public approvalEmpNm2nd: string
    public approvalDate3rd: string
    public approvalEmpCd3rd: string
    public approvalEmpNm3rd: string
    public confirmDate1st: string
    public confirmEmpCd1st: string
    public confirmEmpNm1st: string
    public confirmDate2nd: string
    public confirmEmpCd2nd: string
    public confirmEmpNm2nd: string
    public confirmDate3rd: string
    public confirmEmpCd3rd: string
    public confirmEmpNm3rd: string
    public creationDate: string
    public creationUser: string
    public renewDate: string
    public renewUser: string


}
